module.exports = __webpack_public_path__ + "static/8-b31b2882861631319d0fef32a608744e.jpg";